const StatusChip = ({color = "green", children, className}) => {
    let colors = {
        green: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#ECF6DC] text-[#16432B]`,
        red: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#E4CCD7] text-[#5E203C]`,
        blue: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#E7FDFF] text-[#204C55]`,
        purple: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[rgb(235,231,255)] text-[rgb(64,26,129)]`
    }
    return(
        <div
            className={`${colors[color]} ${className} capitalize`}
        >
            {children}
        </div>
    )
}

export default StatusChip;